import { useMemo } from "react";
import OrganicSocialOverview from "./OrganicSocialOverview";
import { useChannels } from "Hooks/useChannels";
import { ApiChannelDefault } from "@incendium/api";

function MarketingPerformanceOrganicSocialPage() {
  const { channels } = useChannels();
  const socialChannelName = useMemo(() => {
    return (
      channels.find((c) => c._default === ApiChannelDefault.ORGANIC_SOCIAL)
        ?.name || ""
    );
  }, [channels]);

  return (
    <OrganicSocialOverview
      channelName={socialChannelName}
    />
  );
}

export default MarketingPerformanceOrganicSocialPage;
